import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { actuacionesService } from "../../../../../_services/actuaciones.service";
import { useDispatch, useSelector } from "react-redux";
import { evaluacionesService } from "../../../../../_services/evaluaciones.service";
import { setLoading } from "../../../../../redux/Loading/actions";
import moment from "moment";
import Swal from "sweetalert2";
// import { deudasService } from "../../../../../_services/deudas.service";
import { fixNumber } from "../../../../../utils/utils";
import { configuracionService } from "../../../../../_services/configuracion.service";
import { useUser } from "../../../../../hooks/useUser";


const Evaluacion = ({ show, handleClose, data }) => {
  const dispatch = useDispatch();
  const {
    tipoEtapas,
  } = useSelector(e => e.dashboard);
  const user = useUser();

  const [actuacionesData, setActuacionesData] = useState([]);
  const [actuaciones, setActuaciones] = useState({
    total: 0,
    sin_radicar: 0,
    apremios: 0,
    sin_movimientos: 0,
    sin_archivar: 0,
  });

  const [permitidosData, setPermitidosData] = useState({
    sin_radicar: 0,
    sin_archivar: 0,
    faltantes: 0,
  });
  const [resultados, setResultados] = useState({
    a_radicar: 0,
    sin_radicar: 0,
    archivados: 0,
    sin_archivar: 0,
    restantes: 0,
    faltantes: 0,
  });
  const [porcentajes, setProcentajes] = useState({
    a_radicar: 0,
    archivados: 0,
    faltantes: 0,
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    dispatch(setLoading(true));

    const permitidosRes = await evaluacionesService.getEvaluacionesConfig();
    const permitido_sin_radicar = permitidosRes.find(e => e.categoria === "sin_radicar");
    const permitido_sin_archivar = permitidosRes.find(e => e.categoria === "sin_archivar");
    const permitido_faltantes = permitidosRes.find(e => e.categoria === "faltantes");

    setPermitidosData({
      sin_radicar: permitido_sin_radicar?.maximo,
      sin_archivar: permitido_sin_archivar?.maximo,
      faltantes: permitido_faltantes?.maximo,
    });

    const configuracion = await configuracionService.getConfiguracion({ key: "FECHA_INICIAL" });
    const fecha_inicial = configuracion?.value;

    // const actuacionesRes = await actuacionesService.actuacionesTrimestrales({ abogado: data?.codexterno });
    const actuacionesRes = await actuacionesService.actuacionesSearch({
      data: {
        abogado: data?.codexterno
      },
      abogado: data?.codexterno,
      gruposId: [2, 3]
    }, "evaluacion");

    if (actuacionesRes?.length) {
      const filtered = actuacionesRes.filter((e) => {
        let situacion = "";

        const historicos = e?.imponibles?.map((e) => e?.historico).filter(e => e).sort((a, b) => new Date(a?.fecha) - new Date(b?.fecha));
        if (historicos.length) {
          const historico = historicos[historicos.length - 1];

          if (historico?.SITUACION === "Gestión Legal" || historico?.SITUACION === "Título Ejecutivo") {
            situacion = new Date(historico?.fecha) >= new Date(fecha_inicial);
          }
        }
        const actuaciones = e?.imponibles?.filter((imp) => imp?.actuaciones.filter((ac) => new Date(ac?.fecha) >= new Date(fecha_inicial))?.length);

        return situacion || actuaciones?.length;
      });

      const causas = filtered.map((e) => {
        const actuaciones = e?.imponibles?.filter((imp) => imp?.actuaciones?.length);

        if (actuaciones?.length) {
          const imponibles = e?.imponibles.map((imp) => imp?.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);
          return imponibles?.length ? imponibles[imponibles.length - 1] : null;
        } else {
          const historicos = e?.imponibles?.filter(e => e).sort((a, b) => new Date(a?.historico?.fecha) - new Date(b?.historico?.fecha));

          return historicos?.length ? historicos[historicos.length - 1] : null;
        }
      }).filter(e => e?.historico || e?.tipo_etapa?.evaluacion);

      setActuacionesData(causas);

      const apremios = causas.filter((e) => {
        if (e.historico) {
          return e.historico?.SITUACION === "Título Ejecutivo";
        }
        else {
          return e?.tipo_etapa?.grupo === 3;
        }
      });

      const extrajudiciales = causas.filter((e) => {
        if (e.historico) {
          return e.historico?.SITUACION === "Gestión Legal";
        }
        else {
          return e?.tipo_etapa?.grupo === 2;
        }
      });

      const sin_radicar = causas.filter(e => {
        if (e.historico?.SITUACION === "Gestión Legal") {
          let tipo = tipoEtapas.find((e) => e.nombre === "Plazo máximo para iniciar el apremio");
          const b = new Date().getTime() > new Date(moment(e.historico.fecha).add(tipo.tiempo, tipo.tipo_tiempo).format("YYYY-MM-DD")).getTime();

          return b;
        } else {
          const fecha_limite = moment(e.fecha).add("day", 90).format("YYYY-MM-DD");

          const b = new Date().getTime() > new Date(fecha_limite).getTime();
          return e?.tipo_etapa?.grupo === 2 && b;
        }
      });

      const activos = apremios.filter(e => e.tipo_etapa?.estado?.toLowerCase() === "activo");
      // const archivados = apremios.filter(e => e.tipo_etapa.estado?.toLowerCase() === "archivado");

      const sin_movimientos = activos.filter(e => {
        const b = new Date().getTime() > new Date(moment(e.fecha).add(e.tipo_etapa.tiempo, e.tipo_etapa.tipo_tiempo).format("YYYY-MM-DD")).getTime();
        return b;
      });

      setActuaciones({
        total: causas?.length,
        sin_radicar: extrajudiciales?.length,
        apremios: apremios?.length,
        sin_movimientos: sin_movimientos?.length,
        sin_archivar: activos?.length,
      });

      setResultados({
        a_radicar: extrajudiciales?.length,
        sin_radicar: sin_radicar?.length,
        archivados: apremios?.length,
        sin_archivar: activos?.length,
        restantes: apremios?.length,
        faltantes: sin_movimientos?.length,
      });

      setProcentajes({
        a_radicar: fixNumber((sin_radicar.length * 100) / extrajudiciales.length),
        archivados: fixNumber((activos.length * 100) / apremios.length),
        faltantes: fixNumber((sin_movimientos.length * 100) / apremios.length),
      });
    }
    dispatch(setLoading(false));
  };

  const handleSave = () => {
    return Swal.fire({
      title: "¿Esta seguro?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const a_radicar = porcentajes.a_radicar <= +permitidosData.sin_radicar;
        const archivados = porcentajes.archivados <= +permitidosData.sin_archivar;
        const faltantes = porcentajes.faltantes <= +permitidosData.faltantes;

        const response = await evaluacionesService.create({
          abogado: data.codexterno,
          maximoSinRadicar: permitidosData.sin_radicar,
          maximoSinArchivar: permitidosData.sin_archivar,
          maximoFaltantes: permitidosData.faltantes,
          actuaciones: actuacionesData.map(e => e?.id_etapa ? e : e.historico),
          resultado: a_radicar && archivados && faltantes ? "Aprobado" : "Desaprobado",
          cantidadJuicios: JSON.stringify(actuaciones),
          cantidadTotal: JSON.stringify(resultados),
        });
        if (response.ok) {
          Swal.fire({
            title: "Éxito!",
            icon: "success",
            willOpen: () => handleClose()
          });
        }
        else {
          Swal.fire(
            "Error!",
            "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };


  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
        className="evaluaciones-modal"
        centered
      >
        <Modal.Header closeButton>
          <div className="mt-3 ml-3">
            <b>
              CONFIGURACIÓN
            </b>
          </div>
        </Modal.Header>
        <Modal.Body className="p-5">
          <div>
            <div className="mb-4">
              <table className="w-full" style={{ border: "1px solid #C5E0FF", borderRadius: 8 }}>
                <thead>
                  <tr>
                    <th className="text-center p-3">ABOGADO</th>
                    <th className="text-center p-3">DNI</th>
                    <th className="text-center p-3">CODEXTERNO</th>
                    <th className="text-center p-3">MATRÍCULA</th>
                    <th className="text-center p-3">BAJA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ background: "#F2F7FF" }}>
                    <td className="text-center p-3">{data?.apellido_nombre}</td>
                    <td className="text-center p-3">{data?.nrodni}</td>
                    <td className="text-center p-3">{data?.codexterno}</td>
                    <td className="text-center p-3">{data?.matricula}</td>
                    <td className="text-center p-3">{data?.baja}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="p-3 eval-cantidad">
              <div className="d-flex my-1">
                <div className="juicios">Total de asignaciones:</div>
                <div className="evaluacion-form">{actuaciones.total}</div>
              </div>
              <div className="d-flex my-1">
                <div className="juicios">Total de asignaciones sin radicar:</div>
                <div className="evaluacion-form">{actuaciones.sin_radicar}</div>
              </div>
              <div className="d-flex my-1">
                <div className="juicios">Total de apremios:</div>
                <div className="evaluacion-form">{actuaciones.apremios}</div>
              </div>
              <div className="d-flex my-1">
                <div className="juicios">Total de apremios sin movimientos o faltantes:</div>
                <div className="evaluacion-form">{actuaciones.sin_movimientos}</div>
              </div>
              <div className="d-flex my-1">
                <div className="juicios">Total de apremios sin archivar:</div>
                <div className="evaluacion-form">{actuaciones.sin_archivar}</div>
              </div>
            </div>
            <div>
              <table className="w-full">
                <tr style={{ background: "#0477AD", color: "white" }}>
                  <th></th>
                  <th className="text-right py-1">% permitido</th>
                  <th className="text-right py-1">% obtenido</th>
                </tr>
                <tr>
                  <td className="px-2 pt-2">Porcentaje máximo de asignaciones sin radicar:</td>
                  <td className="px-2 pt-2 text-right">
                    <div className="d-flex align-items-center evaluacion-form">{permitidosData.sin_radicar} %</div>
                  </td>
                  <td className="px-2 pt-2 text-right">
                    <b className={`${porcentajes.a_radicar <= +permitidosData.sin_radicar ? "aprobado" : "desaprobado"}`}>
                      {`${porcentajes.a_radicar}%`}
                    </b>
                    <b> {`(${resultados.sin_radicar}/${resultados.a_radicar})`}</b>
                  </td>
                </tr>
                <tr>
                  <td className="px-2 pt-1">Porcentaje máximo de apremios con faltantes o sin movimientos:</td>
                  <td className="px-2 pt-1 text-right">
                    <div className="d-flex align-items-center evaluacion-form">{permitidosData.faltantes} %</div>
                  </td>
                  <td className="px-2 pt-1 text-right">
                    <b className={`${porcentajes.faltantes <= +permitidosData.faltantes ? "aprobado" : "desaprobado"}`}>
                      {`${porcentajes.faltantes}%`}
                    </b>
                    <b> {`(${resultados.faltantes}/${resultados.restantes})`}</b>
                  </td>
                </tr>
                <tr>
                  <td className="px-2 pt-1">Porcentaje máximo de apremios sin archivar:</td>
                  <td className="px-2 pt-1 text-right">
                    <div className="d-flex align-items-center evaluacion-form">{permitidosData.sin_archivar} %</div>
                  </td>
                  <td className="px-2 pt-1 text-right">
                    <b className={`${porcentajes.archivados <= +permitidosData.sin_archivar ? "aprobado" : "desaprobado"}`}>
                      {`${porcentajes.archivados}%`}
                    </b>
                    <b> {`(${resultados.sin_archivar}/${resultados.archivados})`}</b>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {user.abogado === "A00" && (
            <Button style={{ background: "#0477AD", color: "white" }} onClick={handleSave} >Realizar evaluación</Button>
          )}
          <Button variant="danger" onClick={handleClose}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Evaluacion;
